import React, { useState } from "react";
import { Custom, Conversation } from "components";
import { Helpers, Store } from "utils";
import { useApp } from "context";
import { useForm } from "hooks";
import { IMessage, IPatient } from "interfaces";
import { PairValue } from "types";

type Props = {
  receiverId: number;
  onSubmit: (message: IMessage) => void;
};

export const Chat = (props: Props) => {
  const { t, user, service } = useApp();
  const [options, setOptions] = useState([]);

  const initialState = {
    message: "",
  };

  const { onChange, onCustomChange, onSubmit, values } = useForm(
    submitCallback,
    initialState
  );

  const isClinic = Store.sessionStorage.isClinic();

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await service.patient.find();
      setOptions(
        response.map(
          (item: IPatient, i: number) =>
            ({
              key: i,
              value: Helpers.replaceComma(item.username),
            } as PairValue)
        )
      );
    };
    isClinic && fetchData();
  }, []);

  async function submitCallback() {
    const { message }: any = values;
    if (Helpers.hasValue(message)) {
      const response = await service.message.send(
        user.userId,
        props.receiverId,
        message,
        new Date()
      );
      props.onSubmit && props.onSubmit(response);
    }
  }

  function handleSubmit(event: any) {
    event.preventDefault();
    // TODO: may be improved
    event.target.reset();
    event.target[0].dispatchEvent(new Event("change", { bubbles: true }));
    onSubmit(event);
  }

  return (
    <form onSubmit={handleSubmit} className="qh-form">
      {isClinic ? (
        <Conversation.MentionTextField
          name="message"
          options={options}
          onChange={onCustomChange}
          placeholder={t.placeholder.type_message}
        />
      ) : (
        <Custom.TextField
          name="message"
          onChange={onChange}
          placeholder={t.placeholder.type_message}
        />
      )}
      <div className="qh-control">
        <Custom.Button submit>{t.action.send}</Custom.Button>
      </div>
    </form>
  );
};
